// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"folder-open-1"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M1 3.5V20L4 10L19.5 10L19.5 6L10 6L7 3.5H1Z"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 20L19.5 20L22.5 10L4 10L1 20Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1 20H19.5L22.5 10H4L1 20ZM1 20L1 3.5L7 3.5L10 6L19.5 6L19.5 10","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FolderOpen1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'folder-open-1',
    ref,
    icon: element,
  },
));

FolderOpen1Icon.displayName = 'FolderOpen1Icon';

export default FolderOpen1Icon;
